import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

export default function BrandsSection() {
  const { t } = useTranslation();
  const [ref, isInView] = useInView({ threshold: 0.1 });

  const brands = [
    { name: 'Apple', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/apple.svg' },
    { name: 'Asus', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/asus.svg' },
    { name: 'HP', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/hp.svg' },
    { name: 'Dell', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/dell.svg' },
    { name: 'Xiaomi', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/xiaomi.svg' },
    { name: 'Acer', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/acer.svg' },
    { name: 'Lenovo', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/lenovo.svg' },
    { name: 'MSI', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/msi.svg' },
    { name: 'Razer', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/razer.svg' },
    { name: 'Gigabyte', logo: 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/gigabyte.svg' },
  ];

  return (
    <section id="brands" ref={ref} className="py-20 lg:py-24" style={{ backgroundColor: '#f0f4ff' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="inline-block text-sky-500 text-sm font-semibold tracking-widest uppercase mb-3">
            {t('brands.label')}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900">
            {t('brands.title')}
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {brands.map((brand, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 16 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: index * 0.04 }}
            >
              <div className="group bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md hover:border-sky-200 transition-all duration-300 cursor-default flex flex-col items-center justify-center py-6 px-4 gap-3">
                <div className="w-14 h-10 flex items-center justify-center">
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="max-w-full max-h-full object-contain opacity-60 group-hover:opacity-100 transition-opacity duration-300"
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement;
                      target.style.display = 'none';
                      const next = target.nextElementSibling as HTMLElement | null;
                      if (next) next.style.display = 'flex';
                    }}
                  />
                  <span className="hidden text-xs font-bold text-slate-400 items-center justify-center">
                    {brand.name}
                  </span>
                </div>
                <span className="text-xs font-semibold text-slate-500 group-hover:text-sky-600 transition-colors duration-300 text-center">
                  {brand.name}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
